<div class="screen-container">
  <app-card [title]="'highAmountForTurnover.title' | translate">
    <div left-content>
      <div *ngIf="telemarketing" class="tm">
        <p>TM</p>
      </div>
      <div class="text-container">
        <p>
          {{ 'highAmountForTurnover.content' | translate }}
        </p>
      </div>
      <div class="text-container flex amount-container">
        <p class="p-title">
          {{ 'highAmountForTurnover.requestedAmountTitle' | translate }}
        </p>
        <p class="p-amount">
          {{ currentAmount | myCurrency }}
        </p>
        <p class="p-title bold">
          {{ 'highAmountForTurnover.recommendedTitle' | translate }}
        </p>
        <p class="p-amount bold">
          {{ recommendedAmount(this.market) | myCurrency }}
        </p>
      </div>
      <form [formGroup]="highAmountForm">
        <div class="content-container">

          <div class="flex text-container mb-2">
            <div class="icon icon-info picker-text-icon"></div>
            <p class="mb-0 ml-1 picker-text">{{ "highAmountForTurnover.pickToContinue" | translate }}</p>
          </div>

          <div class="tab-container" [ngClass]="{ 'active-manual': tab === 2 }">
            <div class="tab tab-left" [ngClass]="{ 'tab-active': tab === 1 }">
              <input
                type="radio"
                id="left-summary"
                [value]="1"
                [(ngModel)]="tab"
                [ngModelOptions]="{ standalone: true }"
                (click)="adjustToRecommendedAmount()"
              />
              <label for="left-summary">{{
                "highAmountForTurnover.leftTab" | translate
              }}</label>
            </div>
            <div class="tab tab-right" [ngClass]="{ 'tab-active': tab === 2 }">
              <input
                type="radio"
                id="right-summary"
                [value]="2"
                [(ngModel)]="tab"
                [ngModelOptions]="{ standalone: true }"
                (click)="adjustToRequestedAmount()"
              />
              <label for="right-summary">{{
                "highAmountForTurnover.rightTab" | translate
              }}</label>
            </div>
          </div>

          <div class="slider-container">
            <app-slider
              [header]="'basicInfo.amountTitle'"
              [control]="amount"
              [switchToInputText]="false"
              [error]="getErrors('amount')"
            ></app-slider>
          </div>

        </div>
      </form>
      <div actions class="navigationButtons">
        <app-deeplink-button
          (buttonClicked)="handleNextButtonClick()"
          mat-flat-button
          [text]="!telemarketing ? 'highAmountForTurnover.nextButtonText' : 'highAmountForTurnover.telemarketing.button'"
          [fullWidth]="true"
          [icon]="telemarketing ? 'none' : market === 'se' ? 'mobile-bank-id-icon' : market === 'nl' ? 'idin-icon' : 'none'"
          [disabled]="!tab"
        ></app-deeplink-button>
        <button
          (click)="handleBackButtonClick()"
          mat-flat-button
          color="secondary"
        >
          {{ 'highAmountForTurnover.backButtonText' | translate }}
        </button>
      </div>
      <div class="mat-error error" *ngIf="error">
        {{ error }}
      </div>
    </div>
    <div right-content>
      <app-contact></app-contact>
    </div>
  </app-card>
</div>
